/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiManagementGroupAddPost } from '../fn/group/api-management-group-add-post';
import { ApiManagementGroupAddPost$Params } from '../fn/group/api-management-group-add-post';
import { apiManagementGroupDeletePost } from '../fn/group/api-management-group-delete-post';
import { ApiManagementGroupDeletePost$Params } from '../fn/group/api-management-group-delete-post';
import { apiManagementGroupEditPost } from '../fn/group/api-management-group-edit-post';
import { ApiManagementGroupEditPost$Params } from '../fn/group/api-management-group-edit-post';
import { apiManagementGroupGetActiveGet } from '../fn/group/api-management-group-get-active-get';
import { ApiManagementGroupGetActiveGet$Params } from '../fn/group/api-management-group-get-active-get';
import { apiManagementGroupGetAllGet } from '../fn/group/api-management-group-get-all-get';
import { ApiManagementGroupGetAllGet$Params } from '../fn/group/api-management-group-get-all-get';
import { GroupManagementModelApiRespModel } from '../models/group-management-model-api-resp-model';
import { GroupResp } from '../models/group-resp';
import { GuidApiRespModel } from '../models/guid-api-resp-model';

@Injectable({ providedIn: 'root' })
export class GroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiManagementGroupAddPost()` */
  static readonly ApiManagementGroupAddPostPath = '/api/Management/Group/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManagementGroupAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupAddPost$Response(params?: ApiManagementGroupAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupManagementModelApiRespModel>> {
    return apiManagementGroupAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManagementGroupAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupAddPost(params?: ApiManagementGroupAddPost$Params, context?: HttpContext): Observable<GroupManagementModelApiRespModel> {
    return this.apiManagementGroupAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupManagementModelApiRespModel>): GroupManagementModelApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiManagementGroupEditPost()` */
  static readonly ApiManagementGroupEditPostPath = '/api/Management/Group/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManagementGroupEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupEditPost$Response(params?: ApiManagementGroupEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupManagementModelApiRespModel>> {
    return apiManagementGroupEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManagementGroupEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupEditPost(params?: ApiManagementGroupEditPost$Params, context?: HttpContext): Observable<GroupManagementModelApiRespModel> {
    return this.apiManagementGroupEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupManagementModelApiRespModel>): GroupManagementModelApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiManagementGroupDeletePost()` */
  static readonly ApiManagementGroupDeletePostPath = '/api/Management/Group/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManagementGroupDeletePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupDeletePost$Response(params?: ApiManagementGroupDeletePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GuidApiRespModel>> {
    return apiManagementGroupDeletePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManagementGroupDeletePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiManagementGroupDeletePost(params?: ApiManagementGroupDeletePost$Params, context?: HttpContext): Observable<GuidApiRespModel> {
    return this.apiManagementGroupDeletePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GuidApiRespModel>): GuidApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiManagementGroupGetAllGet()` */
  static readonly ApiManagementGroupGetAllGetPath = '/api/Management/Group/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManagementGroupGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManagementGroupGetAllGet$Response(params?: ApiManagementGroupGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GroupResp>>> {
    return apiManagementGroupGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManagementGroupGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManagementGroupGetAllGet(params?: ApiManagementGroupGetAllGet$Params, context?: HttpContext): Observable<Array<GroupResp>> {
    return this.apiManagementGroupGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GroupResp>>): Array<GroupResp> => r.body)
    );
  }

  /** Path part for operation `apiManagementGroupGetActiveGet()` */
  static readonly ApiManagementGroupGetActiveGetPath = '/api/Management/Group/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManagementGroupGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManagementGroupGetActiveGet$Response(params?: ApiManagementGroupGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GroupResp>>> {
    return apiManagementGroupGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManagementGroupGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManagementGroupGetActiveGet(params?: ApiManagementGroupGetActiveGet$Params, context?: HttpContext): Observable<Array<GroupResp>> {
    return this.apiManagementGroupGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GroupResp>>): Array<GroupResp> => r.body)
    );
  }

}
